module.exports = __webpack_public_path__ + "static/media/map-control-menu.af380a28.svg";